<template>
  <div class="wrapper">
    <header-elem v-show="!isOrgView" />
    <admin-rems
      v-if="user.privileged_user"
    />
    <admin-notifs
      v-if="user.privileged_user"
    />
    <top-notifications
      v-if="userInited"
    />

    <customer-announs
      v-if="['manager' , 'super_admin' , 'subscriber'].includes(userAccount.role)"
    />

    <admin-marketplace v-if="isMarketplaceVisible"  />

    <notification-elem />
    <notary-success />
    <router-view />

    <error-handler />

    <footer-elem v-show="!isOrgView"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Header from '@/templates/Header';
import Footer from '@/templates/Footer';
import Notification from '@/components/Notification';
import NotarySuccess from '@/components/NotarySuccess';
import ErrorHandler from '@/components/ErrorHandler';
import TopNotifications from '@/components/TopNotifications';

export default {
  name: 'layout-panel',
  components: {
    'header-elem': Header,
    'footer-elem': Footer,
    'top-notifications': TopNotifications,
    'notification-elem': Notification,
    'notary-success': NotarySuccess,
    'admin-rems': () => import('@/views/admin/Rems'),
    'admin-notifs': () => import('@/views/admin/Notifs'),
    'admin-marketplace': () => import('@/views/admin/Marketplace.vue'),
    'customer-announs': () => import('@/views/customer/Announs'),
    'error-handler': ErrorHandler
  },
  data() {
    return {
      userInited: false,
      isOrgView: false,
      isMarketplaceVisible: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      provider: 'provider',
      isAdmin: 'isAdmin',
      reminders: 'mail/reminders',
      userAccount: "account/userAccount",
    }),
    form1583Signed() {
      if (!Object.keys(this.user).length)
        return true;

      return (
        this.provider.client_level == 1 ||
        this.user.privileged_user ||
        // !this.userPlan.notarization_service_enabled ||
        this.provider.country_id != 1 ||
        this.user.is_form_1583_signed ||
        this.user.is_form_1583_pending
      );
    }
  },
  created() {
    this.initUser();
  },
  methods:{
    ...mapActions({
      getProvider: 'getProvider',
      getUserAccount: 'account/userData',
      saveForm1583Status: 'account/saveForm1583Status',
    }),
    initUser() {
      Promise.all([
        this.getProvider(),
        this.getUserAccount()
      ])
        .then(([provider, account]) => {
          this.saveForm1583Status(this.form1583Signed);
          this.userInited = true;

          let clientLevel = provider.hasOwnProperty("client") ? provider.client.client_level : provider.client_level;

          this.isMarketplaceVisible = clientLevel != 1  && (["super_admin", "manager"].includes(account.account.role) || account.account.is_organization_admin)
        });
    }
  },
  watch: {
    form1583Signed(val) {
      this.saveForm1583Status(val);
    },
    isAdmin(val) {
      this.initUser();
    },
    '$route': {
      immediate: true,
      handler(to, from) {
        const currPath = to.fullPath;
        const currView = currPath.split('/')[2];
        const OrgViews = ['locations', 'org-reports'];
        this.isOrgView = OrgViews.includes(currView) ? true : false;
      }
    }
  }
}
</script>
